module.exports = __webpack_public_path__ + "img/logo.158de976.png";